"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRow = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const react_phone_number_input_1 = __importDefault(require("react-phone-number-input")); // Component
// Note: forwardRef sucks with typescript, but might not be necessary.
var Input = /*#__PURE__*/ react_1.default.forwardRef(function (props, _) {
    var name = props.name, type = props.type, icon = props.icon, _props$iconColor = props.iconColor, iconColor = _props$iconColor === void 0 ? _theme_1.palette.ink : _props$iconColor, label = props.label, message = props.message, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, _props$noBorder = props.noBorder, noBorder = _props$noBorder === void 0 ? false : _props$noBorder, _props$emptyFirstOpti = props.emptyFirstOption, emptyFirstOption = _props$emptyFirstOpti === void 0 ? false : _props$emptyFirstOpti, className = props.className, _onChange = props.onChange, value = props.value, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$processing = props.processing, processing = _props$processing === void 0 ? false : _props$processing, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, inputRef = props.inputRef, autoComplete = props.autoComplete, children = props.children, _props$capitalize = props.capitalize, capitalize = _props$capitalize === void 0 ? true : _props$capitalize;
    var hasIcon = !!icon;
    var _React$useState = react_1.default.useState(false), valid = _React$useState[0], setValid = _React$useState[1];
    var _React$useState2 = react_1.default.useState(false), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(false), filled = _React$useState3[0], setFilled = _React$useState3[1];
    var nonNativeInput = !!children;
    react_1.default.useEffect(function () {
        if (!type) {
            // If no type (input is a child element, like say a Stripe Element) manually handle focus/fill state.
            // This might be a better way to handle "tel"
            setValid(focused || filled);
        }
        else if (type === 'select' || type === 'tel') {
            // If a select or tel, determine based on value.
            setValid(value !== "" && value !== undefined);
        }
    }, [type, value, focused, filled]);
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        className: className
    }, icon && /*#__PURE__*/ react_1.default.createElement(StyledIcon, {
        withMobile: true,
        color: iconColor
    }, icon), /*#__PURE__*/ react_1.default.createElement(atoms_1.Spinner, {
        color: _theme_1.palette.karaka,
        hidden: !processing
    }), /*#__PURE__*/ react_1.default.createElement(InputWrapper, {
        hasIcon: hasIcon,
        disabled: disabled,
        noBorder: noBorder,
        nonNativeInput: nonNativeInput
    }, (type === 'text' || type === 'email' || type === 'password') && /*#__PURE__*/ react_1.default.createElement("input", Object.assign({
        onChange: _onChange,
        disabled: disabled,
        required: required,
        value: value,
        type: type,
        name: name,
        autoComplete: autoComplete
    }, {
        placeholder: " ",
        id: name,
        ref: inputRef
    })), type === 'textarea' && /*#__PURE__*/ react_1.default.createElement("textarea", Object.assign({
        onChange: _onChange,
        disabled: disabled,
        required: required,
        value: value,
        name: name
    }, {
        placeholder: " ",
        id: name
    })), type === 'tel' && /*#__PURE__*/ react_1.default.createElement(StyledPhoneInput, Object.assign({
        countrySelectProps: {
            unicodeFlags: true
        },
        defaultCountry: "US"
    }, {
        onChange: _onChange,
        disabled: disabled,
        required: required,
        value: value,
        name: name
    }, {
        id: name
    })), type === 'select' && options && /*#__PURE__*/ react_1.default.createElement(DropdownWrapper, {
        className: "dropdownWrapper"
    }, /*#__PURE__*/ react_1.default.createElement(Dropdown, Object.assign({
        onChange: _onChange,
        disabled: disabled,
        noBorder: noBorder,
        required: required,
        value: value,
        name: name,
        capitalize: capitalize
    }, {
        className: "custom",
        id: name
    }), emptyFirstOption && !required && /*#__PURE__*/ react_1.default.createElement("option", {
        value: ""
    }), emptyFirstOption && required && /*#__PURE__*/ react_1.default.createElement("option", {
        disabled: true,
        value: ""
    }), Array.isArray(options) && options.map(function (option) {
        return /*#__PURE__*/ react_1.default.createElement("option", {
            value: option,
            key: option
        }, option);
    }), !Array.isArray(options) && Object.keys(options).map(function (key) {
        return /*#__PURE__*/ react_1.default.createElement("option", {
            value: key,
            key: key
        }, options[key]);
    }))), !type && children && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, function (child) {
        return child && /*#__PURE__*/ react_1.default.cloneElement(child, {
            onFocus: function onFocus() {
                return setFocused(true);
            },
            onBlur: function onBlur() {
                return setFocused(false);
            },
            onChange: function onChange(e) {
                if (_onChange !== undefined)
                    _onChange(e);
                setFilled(!e.empty);
            },
            name: name
        });
    })), /*#__PURE__*/ react_1.default.createElement(Label, Object.assign({
        hasIcon: hasIcon,
        type: type
    }, {
        className: valid ? 'valid' : '',
        htmlFor: name
    }), label, required ? ' *' : '')), message && /*#__PURE__*/ react_1.default.createElement(Message, null, message));
}); // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Input__Wrapper",
    componentId: "sc-16ey1rd-0"
})(["position:relative;width:100%;height:fit-content;"]);
var StyledIcon = styled_components_1.default(atoms_1.Icon).withConfig({
    displayName: "Input__StyledIcon",
    componentId: "sc-16ey1rd-1"
})(["z-index:2;position:absolute;top:0;right:16px;bottom:0;margin:auto 0;", "{right:24px;}", "{right:32px;}"], _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Label = styled_components_1.default.label.withConfig({
    displayName: "Input__Label",
    componentId: "sc-16ey1rd-2"
})(["position:absolute;left:16px;top:0;display:flex;align-items:center;height:100%;width:calc(100% - 32px);", " ", " color:", ";transform:translate3d(0,0,0) scale3d(1,1,1);transform-origin:center left;transition:color 0.3s ease-in-out,transform 0.3s ease-in-out;will-change:color,transform;pointer-events:none;.PhoneInput:focus-within ~ &,input:focus ~ &,input:not(:placeholder-shown) ~ &,input:required:valid ~ &,textarea:focus ~ &,textarea:not(:placeholder-shown) ~ &,textarea:required:valid ~ &,.dropdownWrapper:focus-within ~ &,&.valid{transform:translate3d(0,-12px,0) scale3d(0.8,0.8,1);color:", ";}", "{", "}", "{left:24px;width:calc(100% - 48px);}", "{left:32px;width:calc(100% - 64px);}"], function (props) {
    return props.type === 'textarea' && "\n    height: auto !important;\n    padding-top: 24px;\n  ";
}, _theme_1.type.pLargeSans, _theme_1.palette.rifle, _utils_1.rgba(_theme_1.palette.rifle, 0.8), _utils_1.mediaQuery('tablet'), function (props) {
    return props.type === 'textarea' && "\n      padding-top: 32px;\n    ";
}, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Message = styled_components_1.default.div.withConfig({
    displayName: "Input__Message",
    componentId: "sc-16ey1rd-3"
})(["position:absolute;bottom:-15px;left:25px;color:red;"]); // note: noBorder should possible be renamed "invert" to reflect that it goes over black backgrounds
var InputWrapper = styled_components_1.default.div.withConfig({
    displayName: "Input__InputWrapper",
    componentId: "sc-16ey1rd-4"
})(["position:relative;input,textarea,select.custom{position:relative;display:flex;justify-content:center;align-items:center;background-color:", ";width:100%;height:56px;border:", "px solid ", ";border-radius:0;outline:none;color:", ";transition:background-color 0.3s ease-in-out,border-color 0.3s ease-in-out,opacity 0.3s ease-in-out;will-change:background,border;pointer-events:", ";opacity:", ";appearance:none;", " text-indent:0;padding:18px ", "px 0 16px;", "{padding-right:", "px;}", "{height:64px;padding:20px ", "px 0 24px;}", "{height:72px;padding:22px ", "px 0 32px;}}", " input:focus,textarea:focus,select.custom:focus{background-color:", ";", "}textarea{height:auto;min-height:168px;padding:48px 16px 16px;resize:vertical;", "{padding-top:40px;}", "{min-height:192px;padding:40px 24px 24px;}", "{min-height:216px;padding:48px 32px 32px;}}"], function (props) {
    return props.noBorder ? _theme_1.palette.snow : _utils_1.rgba(_theme_1.palette.snow, 0.8);
}, function (props) {
    return props.noBorder ? 0 : 1;
}, _utils_1.rgba(_theme_1.palette.ink, 0.32), _theme_1.palette.ink, function (props) {
    return props.disabled ? 'none' : 'inherit';
}, function (props) {
    return props.disabled ? 0.5 : 1;
}, _theme_1.type.pXLargeSans, function (props) {
    return props.hasIcon ? 48 : 16;
}, _utils_1.mediaQuery('tablet'), function (props) {
    return props.hasIcon ? 56 : 16;
}, _utils_1.mediaQuery('laptop'), function (props) {
    return props.hasIcon ? 72 : 24;
}, _utils_1.mediaQuery('desktop'), function (props) {
    return props.hasIcon ? 88 : 32;
}, function (props) {
    return props.nonNativeInput && "\n    width: 100%;\n    height: 56px;\n    border: " + (props.noBorder ? 0 : 1) + "px solid " + _utils_1.rgba(_theme_1.palette.ink, 0.32) + ";\n    background-color: " + (props.noBorder ? _theme_1.palette.snow : _utils_1.rgba(_theme_1.palette.snow, 0.8)) + ";\n    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out;\n    padding: 0;\n    & iframe {\n      pointer-events: " + (props.disabled ? 'none' : 'all') + ";\n      opacity: " + (props.disabled ? 0.5 : 1) + ";\n    }\n\n    " + _utils_1.mediaQuery('laptop') + " {\n      height: 64px;\n    }\n\n    " + _utils_1.mediaQuery('desktop') + " {\n      height: 72px;\n    }\n\n    & .stripePadding {\n      background: rgba(palette.snow, 0.8);\n      padding: 25.5px 16px 9.5px 16px;\n\n      " + _utils_1.mediaQuery('laptop') + " {\n        padding: 31px 24px 12px 24px;\n      }\n  \n      " + _utils_1.mediaQuery('desktop') + " {\n        padding: 36px 32px 15px 32px;\n      }\n    }\n  \n  ";
}, _theme_1.palette.white, function (props) {
    return props.noBorder ? '' : 'border-color:' + _utils_1.rgba(_theme_1.palette.ink, 0.64) + ';';
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Selects
var DropdownWrapper = styled_components_1.default.div.withConfig({
    displayName: "Input__DropdownWrapper",
    componentId: "sc-16ey1rd-5"
})(["position:relative;width:100%;height:auto;&:focus-within::after{transform:rotate3d(0,0,1,180deg);}&::after{position:absolute;top:50%;bottom:50%;right:16px;background:", ";width:10px;height:6px;margin:auto 0;clip-path:polygon(0 0,50% 100%,100% 0);content:'';transform:rotate3d(0,0,1,0deg);transition:transform 0.25s ease-in-out;will-change:transform;}", "{&::after{right:24px;width:12px;height:8px;}}", "{&::after{right:32px;}}"], _theme_1.palette.ink, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Dropdown = styled_components_1.default.select.withConfig({
    displayName: "Input__Dropdown",
    componentId: "sc-16ey1rd-6"
})(["display:flex;align-items:center;background-color:", ";width:100%;height:56px;margin:0;border-radius:0;outline:none;appearance:none;text-transform:", ";cursor:pointer;&::-moz-focus-inner{outline:none !important;}&:-moz-focusring{color:inherit;}&::-ms-expand{display:none;}&:hover,&:focus{outline:none;}& option{font-weight:normal;}", "{height:64px;}", "{height:72px;}"], _theme_1.palette.ink, function (props) {
    return props.capitalize ? 'capitalize' : 'none';
}, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.InputRow = styled_components_1.default.div.withConfig({
    displayName: "Input__InputRow",
    componentId: "sc-16ey1rd-7"
})(["margin-bottom:16px;> *{margin-bottom:16px;&:last-child{margin-bottom:0;}}", ""], function (props) {
    return props.split && "\n    @media only screen and (min-width: " + _theme_1.breakpoint[props.split === true ? 'phone' : props.split] + ") {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      margin-bottom: 0;\n\n      > * {\n        width: calc(50% - 8px);\n      }\n    }\n  ";
});
var StyledPhoneInput = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(react_phone_number_input_1.default, props);
}).withConfig({
    displayName: "Input__StyledPhoneInput",
    componentId: "sc-16ey1rd-8"
})([".PhoneInputCountry{z-index:1;position:absolute;top:50%;right:0;display:flex;align-items:center;justify-content:center;width:72px;height:100%;transform:translateY(-50%);select{position:absolute;right:0;width:100%;height:100%;opacity:0;}.PhoneInputCountryIconUnicode{position:absolute;display:flex;width:24px;height:16px;pointer-events:none;font-size:2.4rem;line-height:2.4rem;}", "{width:80px;}", "{width:88px;}}input.PhoneInputInput{padding-right:72px;", "{padding-right:80px;}", "{padding-right:88px;}}"], _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = Input;
